/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AnalysisResultDto,
  ErrorResponseOfPtw100BadRequestException,
  ErrorResponseOfPtw100MaintenanceModeException,
  ErrorResponseOfPtw100UnauthorizedException,
} from '../models/index';
import {
    AnalysisResultDtoFromJSON,
    AnalysisResultDtoToJSON,
    ErrorResponseOfPtw100BadRequestExceptionFromJSON,
    ErrorResponseOfPtw100BadRequestExceptionToJSON,
    ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON,
    ErrorResponseOfPtw100MaintenanceModeExceptionToJSON,
    ErrorResponseOfPtw100UnauthorizedExceptionFromJSON,
    ErrorResponseOfPtw100UnauthorizedExceptionToJSON,
} from '../models/index';

export interface GetMeasurementAnalysisResultsRequest {
    measurementGroupId: string;
}

/**
 * 
 */
export class MeasurementDataApi extends runtime.BaseAPI {

    /**
     * Returns the analysis result of the given measurement group.
     */
    async getMeasurementAnalysisResultsRaw(requestParameters: GetMeasurementAnalysisResultsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        if (requestParameters['measurementGroupId'] == null) {
            throw new runtime.RequiredError(
                'measurementGroupId',
                'Required parameter "measurementGroupId" was null or undefined when calling getMeasurementAnalysisResults().'
            );
        }


        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/measurement-data/profiles-analysis-result/{measurementGroupId}`.replace(`{${"measurementGroupId"}}`, encodeURIComponent(String(requestParameters['measurementGroupId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => AnalysisResultDtoFromJSON(jsonValue), "AnalysisResultDto" as const);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => AnalysisResultDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     * Returns the analysis result of the given measurement group.
     */
     async getMeasurementAnalysisResults(requestParameters: GetMeasurementAnalysisResultsRequest, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<MeasurementDataApi['getMeasurementAnalysisResultsRaw']>>, AnalysisResultDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = AnalysisResultDto;

         const response = this.getMeasurementAnalysisResultsRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

}
